module.exports = __webpack_public_path__ + "static/media/banner_logo.b2464f47.b2464f47.jpg";